import {
  getTeamLabelByNumber,
  getDefaultStatisticItem
} from '../../utils/utils'

export default {
  statisticScheme: {
    'TIMEOUT': getDefaultStatisticItem('statistic.hockey.timeouts'),
    'BIG_PENALTY': getDefaultStatisticItem('statistic.hockey.big.penalty'),
    'SMALL_PENALTY': getDefaultStatisticItem('statistic.hockey.small.penalty')
  },
  statisticEvents: {
    'TIMEOUT': 'TIMEOUT',
    'BIG_PENALTY': ['5_AND_2_MIN_PENALTY', '5_MIN_PENALTY'],
    'SMALL_PENALTY': ['2_MIN_PENALTY', '5_AND_2_MIN_PENALTY']
  },
  statisticOrder: [
    'TIMEOUT',
    'SMALL_PENALTY',
    'BIG_PENALTY'
  ],
  statisticFunction (event) {
    const { EventCode, GamePeriod, TeamNumber } = event

    if (EventCode !== '2_AND_2_MIN_PENALTY') return

    this.updateStatistic({
      statisticType: 'defaultStatistic',
      property: 'SMALL_PENALTY',
      period: GamePeriod,
      team: getTeamLabelByNumber(TeamNumber),
      type: 'increment',
      value: 2
    })
  },
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}
